(function () {
  function formatMoney(amountCents) {
    const format = theme.settings.moneyFormat || theme.settings.moneyWithCurrencyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amountCents, format);
    }

    const amount = Number.isFinite(amountCents) ? amountCents : 0;
    const value = (amount / 100).toLocaleString(document.documentElement.lang || 'de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (format) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    return `${value} €`;
  }

  function getPanel(root) {
    const blockId = root.dataset.blockId;
    return (
      document.querySelector(`[data-we-pdp-bundle-panel][data-bundle-root="${blockId}"]`) ||
      root.querySelector('[data-we-pdp-bundle-panel]')
    );
  }

  function getCheckboxes(root) {
    const panel = getPanel(root);
    // Panel starts inside root and is only portaled to body on first open.
    // Exclude nested panel nodes from the root query so items aren't counted twice.
    const fromRoot = Array.from(root.querySelectorAll('.we-pdp-bundle__checkbox')).filter(
      (checkbox) => !panel || !panel.contains(checkbox)
    );
    const fromPanel = panel ? Array.from(panel.querySelectorAll('.we-pdp-bundle__checkbox')) : [];
    return fromRoot.concat(fromPanel);
  }

  function getSelectedVariantOption(row) {
    return row?.querySelector('.we-pdp-bundle__variant-select')?.selectedOptions?.[0];
  }

  function getQtyRoot(row) {
    return row?.querySelector('[data-we-pdp-bundle-qty]');
  }

  function getQtyInput(row) {
    const qtyRoot = getQtyRoot(row);
    if (!qtyRoot) return null;

    const custom = qtyRoot.querySelector('.qty-input__custom-input:not([hidden])');
    if (custom) return custom;

    const select = qtyRoot.querySelector('.qty-input__select:not([hidden])');
    if (select) return select;

    return qtyRoot.querySelector('.qty-input__input');
  }

  function getRowQuantity(row) {
    const qtyInput = getQtyInput(row);
    if (!qtyInput) return 1;

    const min = Math.max(1, parseInt(qtyInput.min || '1', 10) || 1);
    const max = qtyInput.max ? parseInt(qtyInput.max, 10) : NaN;
    let qty = parseInt(qtyInput.value, 10);

    if (!Number.isFinite(qty) || qty < min) qty = min;
    if (Number.isFinite(max) && qty > max) qty = max;

    if (String(qty) !== qtyInput.value) qtyInput.value = String(qty);
    return qty;
  }

  function setQtyControlsDisabled(row, disabled) {
    const qtyRoot = getQtyRoot(row);
    if (!qtyRoot) return;

    qtyRoot.classList.toggle('we-pdp-bundle__qty--disabled', disabled);
    qtyRoot.querySelectorAll('input, select, button').forEach((el) => {
      el.disabled = disabled;
    });
  }

  function syncQtyMax(row, inventoryMax) {
    const qtyRoot = getQtyRoot(row);
    const qtyInput = getQtyInput(row);
    const qtyEl = qtyRoot?.querySelector('quantity-input');
    if (!qtyInput) return;

    if (inventoryMax) {
      qtyInput.max = inventoryMax;
      if (qtyEl) qtyEl.dataset.inventoryMax = inventoryMax;
    } else {
      qtyInput.removeAttribute('max');
      if (qtyEl) delete qtyEl.dataset.inventoryMax;
    }

    getRowQuantity(row);
  }

  function getAddButtons(root) {
    const panel = getPanel(root);
    const fromRoot = Array.from(root.querySelectorAll('[data-we-pdp-bundle-add]')).filter(
      (button) => !panel || !panel.contains(button)
    );
    const fromPanel = panel ? Array.from(panel.querySelectorAll('[data-we-pdp-bundle-add]')) : [];
    return fromRoot.concat(fromPanel);
  }

  function updateState(root) {
    const checkboxes = getCheckboxes(root);
    const buttons = getAddButtons(root);

    let total = 0;
    let selectedCount = 0;

    checkboxes.forEach((checkbox) => {
      const row = checkbox.closest('.we-pdp-bundle__row');
      const selectedVariantOption = getSelectedVariantOption(row);

      if (selectedVariantOption) {
        const available = selectedVariantOption.dataset.available === 'true';
        const badge = row.querySelector('[data-we-pdp-bundle-badge]');
        const item = row.closest('.we-pdp-bundle__item');
        const inventoryMax = selectedVariantOption.dataset.inventoryMax;

        checkbox.disabled = !available;
        checkbox.dataset.variantId = selectedVariantOption.value;
        checkbox.dataset.price = selectedVariantOption.dataset.price || '0';

        syncQtyMax(row, inventoryMax);

        if (!available) checkbox.checked = false;
        setQtyControlsDisabled(row, !available);
        item?.classList.toggle('we-pdp-bundle__item--sold-out', !available);
        if (badge) badge.hidden = available;
      }

      if (checkbox.disabled || !checkbox.checked) return;

      const qty = getRowQuantity(row);
      selectedCount += qty;
      const price = parseInt(selectedVariantOption?.dataset.price || checkbox.dataset.price || '0', 10);
      if (Number.isFinite(price)) total += price * qty;
    });

    if (buttons.length === 0) return;

    const labelText = `${buttons[0].dataset.label || buttons[0].textContent.trim()} (${selectedCount} Artikel) - ${formatMoney(total)}`;
    buttons.forEach((button) => {
      button.textContent = labelText;
      button.disabled = selectedCount === 0;
    });
  }

  function openPanel(root) {
    const panel = getPanel(root);
    const openButton = root.querySelector('[data-we-pdp-bundle-open]');
    if (!panel) return;

    // Portal to body so sticky/overflow ancestors cannot clip the fixed drawer.
    if (panel.parentElement !== document.body) {
      panel.dataset.bundleRoot = root.dataset.blockId || '';
      document.body.appendChild(panel);
      bindPanelEvents(root, panel);
    }

    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    openButton?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    panel.querySelector('[data-we-pdp-bundle-close]')?.focus();
  }

  function closePanel(root) {
    const panel = getPanel(root);
    const openButton = root.querySelector('[data-we-pdp-bundle-open]');
    if (!panel) return;

    panel.classList.remove('is-open');
    openButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');

    window.setTimeout(() => {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 300);

    openButton?.focus();
  }

  function handleBundleInteraction(root, event) {
    if (event.target.closest('[data-we-pdp-bundle-open]')) {
      event.preventDefault();
      openPanel(root);
      return;
    }

    if (event.target.closest('[data-we-pdp-bundle-close]')) {
      event.preventDefault();
      closePanel(root);
      return;
    }

    const button = event.target.closest('[data-we-pdp-bundle-add]');
    if (button) {
      event.preventDefault();
      addBundleToCart(root);
      return;
    }

    // Native controls must keep their default behaviour (select open, checkbox toggle, qty input).
    if (
      event.target.closest(
        'select, .we-pdp-bundle__variant-select-wrapper, .we-pdp-bundle__checkbox, .we-pdp-bundle__qty, quantity-input, label[for]'
      )
    ) {
      return;
    }

    if (event.target.closest('.we-pdp-bundle__media')) return;

    const row = event.target.closest('.we-pdp-bundle__row');
    if (!row) return;

    const checkbox = row.querySelector('.we-pdp-bundle__checkbox');
    if (!checkbox || checkbox.disabled) return;

    event.preventDefault();
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindChangeEvents(scope, root) {
    scope.addEventListener('change', (event) => {
      if (event.target.classList?.contains('we-pdp-bundle__checkbox')) {
        updateState(root);
      } else if (event.target.classList?.contains('we-pdp-bundle__variant-select')) {
        updateRowVariant(root, event.target);
      } else if (event.target.closest?.('[data-we-pdp-bundle-qty]')) {
        getRowQuantity(event.target.closest('.we-pdp-bundle__row'));
        updateState(root);
      }
    });

    scope.addEventListener('input', (event) => {
      if (event.target.closest?.('[data-we-pdp-bundle-qty]')) {
        updateState(root);
      }
    });
  }

  function bindPanelEvents(root, panel) {
    if (!panel || panel.dataset.wePdpBundleBound === '1') return;
    panel.dataset.wePdpBundleBound = '1';

    bindChangeEvents(panel, root);

    // Stop row-toggle handlers from stealing select/qty interactions.
    panel.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('select, .we-pdp-bundle__variant-select-wrapper, .we-pdp-bundle__qty')) {
          event.stopPropagation();
        }
      },
      true
    );

    panel.addEventListener('click', (event) => handleBundleInteraction(root, event));
  }

  function updateRowVariant(root, select) {
    const row = select.closest('.we-pdp-bundle__row');
    const checkbox = row?.querySelector('.we-pdp-bundle__checkbox');
    const option = select.selectedOptions?.[0];
    if (!row || !checkbox || !option) return;

    const available = option.dataset.available === 'true';
    const price = parseInt(option.dataset.price || '0', 10);
    const comparePrice = parseInt(option.dataset.comparePrice || '0', 10);
    const priceEl = row.querySelector('[data-we-pdp-bundle-price]');
    const comparePriceEl = row.querySelector('[data-we-pdp-bundle-compare-price]');
    const badge = row.querySelector('[data-we-pdp-bundle-badge]');
    const item = row.closest('.we-pdp-bundle__item');
    const inventoryMax = option.dataset.inventoryMax;

    checkbox.dataset.variantId = option.value;
    checkbox.dataset.price = String(Number.isFinite(price) ? price : 0);
    checkbox.disabled = !available;
    if (!available) checkbox.checked = false;

    syncQtyMax(row, inventoryMax);
    setQtyControlsDisabled(row, !available);

    if (priceEl) {
      priceEl.textContent = formatMoney(Number.isFinite(price) ? price : 0);
      priceEl.classList.toggle('we-pdp-bundle__price--sale', comparePrice > price);
    }

    if (comparePriceEl) {
      comparePriceEl.hidden = !(comparePrice > price);
      comparePriceEl.textContent = comparePrice > price ? formatMoney(comparePrice) : '';
    }

    const saleBadge = row.querySelector('[data-we-pdp-bundle-sale-badge]');
    if (saleBadge) {
      const saleLabel = option.dataset.saleLabel || '';
      saleBadge.textContent = saleLabel;
      saleBadge.hidden = !saleLabel;
    }

    const imageEl = row.querySelector('[data-we-pdp-bundle-image]');
    const mediaLink = row.querySelector('[data-we-pdp-bundle-media]');
    const imageUrl = option.dataset.image;
    const imageSrcset = option.dataset.imageSrcset;

    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      if (imageSrcset) {
        imageEl.srcset = imageSrcset;
      } else {
        imageEl.removeAttribute('srcset');
      }
    }

    if (mediaLink && option.dataset.url) {
      mediaLink.href = option.dataset.url;
    }

    if (badge) badge.hidden = available;
    item?.classList.toggle('we-pdp-bundle__item--sold-out', !available);

    updateState(root);
  }

  function getSectionsToRender(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((section) => section.section);
    }

    return ['cart-icon-bubble'];
  }

  async function addBundleToCart(root) {
    if (!window.theme?.routes?.cartAdd) return;

    const buttons = getAddButtons(root);
    if (buttons.length === 0 || buttons[0].disabled) return;

    const items = getCheckboxes(root)
      .filter((checkbox) => !checkbox.disabled && checkbox.checked && checkbox.dataset.variantId)
      .map((checkbox) => {
        const row = checkbox.closest('.we-pdp-bundle__row');
        const selectedVariantOption = getSelectedVariantOption(row);

        return {
          id: parseInt(selectedVariantOption?.value || checkbox.dataset.variantId, 10),
          quantity: getRowQuantity(row)
        };
      })
      .filter((item) => Number.isFinite(item.id) && item.quantity > 0);

    if (items.length === 0) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = getSectionsToRender(cartDrawer);

    buttons.forEach((button) => {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    });

    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items,
          sections: [...new Set(sections)],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      let error = typeof data.description === 'string' ? data.description : data.message;
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map((item) => item[1].join(', ')).join(', ');
      }

      if (!response.ok) throw new Error(error || response.status);

      if (theme.settings.afterAtc === 'page') {
        window.location.href = theme.routes.cart;
        return;
      }

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
      }

      if (cartDrawer) {
        cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
      } else if (window.location.pathname === theme.routes.cart) {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.refresh();
      }

      root.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          cart: data,
          variantId: items[0].id
        }
      }));
    } catch (error) {
      root.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: error.message
        }
      }));
    } finally {
      buttons.forEach((button) => button.removeAttribute('aria-busy'));
      updateState(root);
      closePanel(root);
    }
  }

  function bindBundle(root) {
    if (!root || root.dataset.wePdpBundleBound === '1') return;
    root.dataset.wePdpBundleBound = '1';

    bindChangeEvents(root, root);

    root.addEventListener(
      'pointerdown',
      (event) => {
        if (event.target.closest('select, .we-pdp-bundle__variant-select-wrapper, .we-pdp-bundle__qty')) {
          event.stopPropagation();
        }
      },
      true
    );

    root.addEventListener('click', (event) => handleBundleInteraction(root, event));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && getPanel(root) && !getPanel(root).hidden) {
        closePanel(root);
      }
    });

    updateState(root);
  }

  function initBundles(scope = document) {
    scope.querySelectorAll('we-pdp-bundle').forEach(bindBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBundles());
  } else {
    initBundles();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('we-pdp-bundle').forEach((node) => {
      delete node.dataset.wePdpBundleBound;
      bindBundle(node);
    });
  });
})();
